<template>
  <div class="app-container menus">
    <el-form
      :model="queryParams"
      ref="queryForm"
      v-hasPermi="['system:mem:list']"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
      style="width: 100%; height: 0.5%; text-align: left"
    >
      <el-form-item label="选择学校" prop="bumencId">
        <treeselect
          v-model="queryParams.bumencId"
          class="treeselect-main"
          :options="querySchool"
          :normalizer="normalizer"
          placeholder="请选择学校"
          :disable-branch-nodes="true"
          loadingText
          noOptionsText="无数据"
          :show-count="true"
        />
      </el-form-item>
      <el-form-item label="考试名称" prop="status">
        <el-select
          v-model="queryParams.eid"
          placeholder="请选择考试名称"
          clearable
          size="small"
          style="width: 240px"
        >
          <el-option
            v-for="dict in examlts"
            :key="dict.eid"
            :label="dict.title"
            :value="dict.eid"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="用户名称" prop="userName">
        <el-input
          v-model="queryParams.userName"
          placeholder="请输入用户名称"
          clearable
          size="small"
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入手机号"
          clearable
          size="small"
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <!-- <el-form-item label="操作时间">
        <el-date-picker
          v-model="dateRange"
          size="small"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          v-hasPermi="['system:mem:list']"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          size="mini"
          @click="resetQuery"
          v-hasPermi="['system:mem:list']"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <!-- <el-col :span="1.5">
              <el-button
                      type="danger"
                      plain
                      icon="el-icon-delete"
                      size="mini"
                      :disabled="multiple"
                      @click="handleDelete"
                      v-hasPermi="['system:mem:delete']"
              >删除</el-button>
          </el-col> -->
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['system:mem:exp']"
          >导出</el-button
        >
      </el-col>
    </el-row>

    <el-table
      ref="tables"
      :data="list"
      @selection-change="handleSelectionChange"
      v-loading="loading"
    >
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <el-table-column label="用户编号" align="center" prop="id" />
      <el-table-column
        label="所在学校"
        align="center"
        prop="title"
        width="170"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="用户名称"
        align="center"
        prop="realname"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="手机号"
        align="center"
        prop="mobile"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="考试名称"
        align="center"
        prop="reTitle"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="分数"
        align="center"
        prop="mark"
        width="100"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="考试时长"
        align="center"
        prop="timenum"
        width="100"
      />
      <el-table-column
        label="创建时间"
        align="center"
        prop="createtime"
        width="180"
      />
      <!-- <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['system:mem:edit']"
            >修改</el-button
          >
          <el-button
            v-if="scope.row.parentId !== 0"
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['system:mem:delete']"
            >删除</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <!-- 添加或修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form
        ref="userForm"
        :model="userForm"
        :rules="rules"
        label-width="80px"
        style="width: 100%; height: 100%"
      >
        <!--                <el-form-item prop="bumenpid" disabled="true" />-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名称" prop="realname">
              <el-input
                v-model="userForm.realname"
                controls-position="right"
                :min="0"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="mobile">
              <el-input
                v-model="userForm.mobile"
                controls-position="right"
                :min="0"
                maxlength="11"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="选择学校" prop="bumencid">
              <treeselect
                v-model="userForm.bumencid"
                :options="schoolOptions"
                :disable-branch-nodes="true"
                :show-count="true"
                :normalizer="normalizer"
                placeholder="选择学校"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="QQ" prop="qq">
              <el-input
                v-model="userForm.qq"
                controls-position="right"
                :min="0"
                maxlength="20"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                type="email"
                v-model="userForm.email"
                controls-position="right"
                :min="0"
                maxlength="20"
                autocomplete="off"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="userForm.sex" placeholder="请选择">
                <el-option
                  v-for="dict in userSex"
                  :key="dict.id"
                  :label="dict.value"
                  :value="dict.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="userForm.status">
                <el-radio :label="'1'">正常</el-radio>
                <el-radio :label="'2'">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作系统" prop="os">
              <el-input
                v-model="userForm.os"
                controls-position="right"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户平台" prop="email">
              <el-input
                v-model="userForm.container"
                controls-position="right"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="地址" prop="address">
              <el-input
                type="textarea"
                v-model="userForm.address"
                placeholder="请输入地址"
                maxlength="110"
                autocomplete="off"
                :rows="5"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryUserExam, queryReply } from "@/api/exam/grades";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { schoolList } from "@/api/user/shcool";
import { download } from "@/utils/request";

export default {
  name: "grades",
  components: { Treeselect },
  data() {
    return {
      // 总条数
      total: 0,
      loading: true,
      // 时间区间查询
      dateRange: [],
      ids: [],
      // 表格数据
      list: [],
      // 弹窗标题
      title: "修改会员",
      // 弹窗状态
      open: false,
      // 学校树选项
      schoolOptions: [],
      // 搜索学校树
      querySchool: [],
      // 搜索框是否显示
      showSearch: true,
      // 非多个禁用
      multiple: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        eid: null,
        bumencId: null,
        userName: null,
        phone: null,
      },
      userStatus: [
        { value: "正常", id: 1 },
        { value: "停用", id: 2 },
      ],
      userSex: [
        { value: "男", id: "0" },
        { value: "女", id: "1" },
        { value: "未知", id: "2" },
      ],
      // 用户信息集合
      userForm: {
        id: undefined,
        realname: undefined,
        mobile: undefined,
        sex: undefined,
        bumencid: undefined,
        avatar: undefined,
        qq: undefined,
        email: undefined,
        address: undefined,
        os: undefined,
        container: undefined,
        status: undefined,
      },
      rules: {
        realname: [
          {
            required: true,
            message: "用户名称不能为空",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
        ],
        bumencid: [
          {
            required: true,
            message: "学校不能为空",
            trigger: "blur",
          },
        ],
      },
      examlts: [], // 考试名称
    };
  },
  created() {
    this.getList();
    this.getSchoolOptions();
    this.examName();
  },
  activated() {
    this.getList();
  },
  methods: {
    async examName() {
      let obj = {
        pageNum: 1,
        pageSize: 10000,
      };
      let res = await queryReply(obj);
      res = res.data.data;
      res.forEach((item) => {
        this.examlts.push({ title: item.title, eid: item.id });
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      // this.getSchoolOptions();
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.beginTime = undefined;
      this.queryParams.endTime = undefined;
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 弹窗表单重置
    reset() {
      // 用户信息集合
      this.userForm = {
        id: undefined,
        realname: undefined,
        mobile: undefined,
        sex: undefined,
        bumencid: undefined,
        avatar: undefined,
        qq: undefined,
        email: undefined,
        address: undefined,
        os: undefined,
        container: undefined,
        status: undefined,
      };
      this.resetForm("userForm");
      this.schoolOptions = [];
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.title,
        children: node.children,
      };
    },
    // 多选框
    handleSelectionChange(val) {
      this.ids = val.map((item) => item.id);
      this.multiple = !val.length;
    },
    getSchoolOptions() {
      schoolList().then((res) => {
        if (sessionStorage.getItem("schoolIdList") == "undefined") {
          this.querySchool = this.handleTree(res.data, "id", "parentid");
        } else {
          let arr = sessionStorage.getItem("schoolIdList").split(",");
          let schoolArr = [];
          arr.forEach((item) => {
            res.data.forEach((school) => {
              if (school.id == item) schoolArr.push(school);
            });
          });
          this.querySchool = this.handleTree(schoolArr, "id", "parentid");
        }
      });
    },
    getList() {
      this.loading = true;
      const dataTime = this.dateRange;
      if (dataTime.length > 0) {
        this.queryParams.beginTime = dataTime[0];
        this.queryParams.endTime = dataTime[1];
      }
      let id = sessionStorage.getItem("userId");
      queryUserExam(this.queryParams).then((res) => {
        this.list = res.data.data;
        this.total = res.data.pageBean.count;
        this.loading = false;
      });
    },
    handleUpdate(row) {
      this.reset();
      schoolList().then((res) => {
        this.schoolOptions = this.handleTree(res.data, "id", "parentid");
      });
      const userId = row.id;
      queryUserById({ userId }).then((res) => {
        this.userForm = res.data;
      });
      this.open = true;
    },
    handleDelete(row) {
      const userId = row.id || this.ids;
      this.$confirm(
        '是否确认删除访问编号为"' + userId + '"的数据项？',
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteUserById({ userId }).then((res) => {
            if (res.status === 200) {
              this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出按钮
    handleExport() {
      let id = sessionStorage.getItem("userId");
      download(
        "userExam/exportData",
        this.queryParams,
        `user_${new Date().getTime()}.xls`
      );
    },
    // 弹窗确定按钮
    submitForm() {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          const form = this.userForm;
          updateUserById(form).then((res) => {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.open = false;
            this.getList();
          });
        }
      });
    },
    cancel() {
      this.open = false;
    },
    // 跳转到用户积分列表
    queryCredits(row) {
      // console.log(row);
      this.$router.push({ path: "/Home/credits", query: { userId: row } });
    },
  },
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.mb8 {
  margin: 0 -5px 8px;
}
.treeselect-main {
  width: 280px;
  margin-top: 5px;
  line-height: 30px;
}
.vue-treeselect >>> .vue-treeselect__placeholder {
  line-height: 30px;
}
.vue-treeselect >>> .vue-treeselect__control {
  height: 30px !important;
}
.vue-treeselect >>> .vue-treeselect__menu {
  overflow-x: auto !important;
}
.vue-treeselect >>> .vue-treeselect__label {
  overflow: unset;
  text-overflow: unset;
}
</style>
